import { AdminApp } from "app/AdminApp";
import { PortalApp } from "app/PortalApp";
import { useApp } from "app/appService";
import { BundleIds } from "app/shared/constants";
import { LicenseInfo, muiXTelemetrySettings } from "@mui/x-license";

muiXTelemetrySettings.disableTelemetry();
LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_LICENSE_KEY);

export const App = () => {
  const { bundleId } = useApp();
  switch (bundleId) {
    case BundleIds.MEDONBOARD_ADMIN:
    case BundleIds.MEDACT_ADMIN:
    case BundleIds.MEDLEAVE_ADMIN:
    case BundleIds.RELEASE_MANAGER_ADMIN:
      return <AdminApp />;
    case BundleIds.MEDONBOARD_PORTAL:
      return <PortalApp />;
    default:
      return null;
  }
};
